import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "@context/CartContext.jsx";
import ConfiguratorShortcut from "@components/ConfiguratorShortcut";
import MobileBottomNav from "@components/MobileBottomNav";
import Logo from "@svg/logo.svg";

import '@css/index.css';
import '@css/styles.css';
import '@css/antd.css';
import '@css/fonts.css';
import '@css/scroll.css';

const Home = lazy(() => import("@pages/home/page.jsx"));
const Catalog = lazy(() => import("@pages/home/catalog.jsx"));
const Series = lazy(() => import("@pages/home/series.jsx"));
const AboutUs = lazy(() => import("@pages/home/about.jsx"));
const Contacts = lazy(() => import("@pages/home/contacts.jsx"));
const Cart = lazy(() => import("@pages/home/cart.jsx"));
const Product = lazy(() => import("@pages/home/product.jsx"));
const Configurator = lazy(() => import("@pages/home/configurator.jsx"));
const Admin = lazy(() => import("@pages/admin/page.jsx"));

function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white text-[#1f2a3a]">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#CF5327] border-t-transparent" />
    </div>
  );
}

function App() {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setLoadingProgress((current) => {
        if (current >= 100) {
          window.clearInterval(timer);
          window.setTimeout(() => setShowLoader(false), 350);
          return 100;
        }

        return Math.min(100, current + Math.ceil(Math.random() * 8));
      });
    }, 80);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <CartProvider>
      {showLoader && (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#1f2a3a] text-white">
          <style>{`
            @keyframes loaderLogoFloat {
              0%, 100% { transform: translateY(0) scale(1); opacity: 0.92; }
              50% { transform: translateY(-10px) scale(1.03); opacity: 1; }
            }
          `}</style>

          <div className="relative mb-10 overflow-hidden">
            <img
              src={Logo}
              alt="OrionBoat"
              className="h-auto w-[220px] md:w-[320px]"
              style={{ animation: "loaderLogoFloat 1.8s ease-in-out infinite" }}
            />
          </div>

          <div className="w-[min(420px,78vw)]">
            <div className="mb-3 flex items-center justify-between text-sm font-semibold uppercase urb-r text-white/70">
              <span>Загрузка</span>
              <span>{loadingProgress}%</span>
            </div>
            <div className="h-1.5 overflow-hidden rounded-full bg-white/15">
              <div
                className="h-full rounded-full bg-[#CF5327] transition-[width] duration-150 ease-out urb-r"
                style={{ width: `${loadingProgress}%` }}
              />
            </div>
          </div>
        </div>
      )}
      <Router>
        <div className="App">
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/series" element={<Series />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/in-stock" element={<Catalog stockOnly />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/configurator" element={<Configurator />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
          <ConfiguratorShortcut />
          <MobileBottomNav />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
